<template>
  <div class="base-height_fullscreen">
    <div class="base-flex__between">
      <el-button class="base-margin__bottom-10" type="primary" @click="openDialog">{{
          $t('mirrorManagement.createImage')
        }}
      </el-button>
      <div>
        <el-input v-model="imageIds" class="base-width__320" :placeholder="$t('mirrorManagement.imageIds')" @input="filterGetList"></el-input>
        <el-select class="base-width__200 base-margin__left-20" v-model="filterRegion" clearable @change="filterGetList" :placeholder="$t('mirrorManagement.selectRegion')">
          <el-option
            v-for="item in regionData"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
          <el-select class="base-margin__left-20 base-width__200" clearable multiple v-model="filterPlatform" @change="filterGetList" :placeholder="$t('mirrorManagement.selectImageType')">
            <el-option
              v-for="item in platformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div>
    </div>

    <div class="mirror_table">
      <el-table :data="tableData" class="table">
        <el-table-column :label="$t('mirrorManagement.id')" prop="id" width="50"></el-table-column>
        <el-table-column :label="$t('mirrorManagement.imageName')" prop="name"></el-table-column>
        <el-table-column width="100" :label="$t('mirrorManagement.region')">
          <template slot-scope="scope">
            <span>{{ filterRegionList(scope.row.region) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="100" :label="$t('mirrorManagement.diskSize')" prop="disk"></el-table-column>
        <el-table-column width="200" :label="$t('mirrorManagement.imageId')" prop="value"></el-table-column>
        <el-table-column width="150" :label="$t('mirrorManagement.imageType')" prop="platform"></el-table-column>
        <el-table-column :label="$t('mirrorManagement.osName')" prop="osName"></el-table-column>
        <el-table-column width="100" :label="$t('mirrorManagement.status')">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 2 ? '' : 'success' ">
              {{ scope.row.status === 2 ? $t('mirrorManagement.unavailable') : $t('mirrorManagement.available') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="300" :label="$t('mirrorManagement.bashAddress')" prop="bashFile"></el-table-column>
        <el-table-column width="200" :label="$t('mirrorManagement.createTime')" prop="createTime"></el-table-column>
        <el-table-column
          :label="$t('mirrorManagement.actions')"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editImage(scope.row)">{{ $t('mirrorManagement.edit') }}</el-button>
            <el-button type="text" @click="deleteImage(scope.row.id)">{{ $t('mirrorManagement.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
    </div>

    <!--创建镜像-->
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="formLabelAlign" :model="formLabelAlign" label-width="100px">
        <el-form-item :label="$t('mirrorManagement.imageName')" prop="name">
          <el-input v-model="formLabelAlign.name" :placeholder="$t('mirrorManagement.enterImageName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('mirrorManagement.imageId')" prop="value">
          <el-input v-model="formLabelAlign.value" :placeholder="$t('mirrorManagement.enterImageId')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('mirrorManagement.diskSize')" prop="disk">
          <el-input v-model="formLabelAlign.disk" :placeholder="$t('mirrorManagement.selectDiskSize')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('mirrorManagement.imageType')" prop="platform">
          <el-select v-model="formLabelAlign.platform" :placeholder="$t('mirrorManagement.selectImageType')">
            <el-option
              v-for="item in platformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('mirrorManagement.osName')" prop="bashFile">
          <el-input v-model="formLabelAlign.osName" :placeholder="$t('mirrorManagement.enterOsName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('mirrorManagement.region')" prop="region">
          <el-select v-model="formLabelAlign.region" :placeholder="$t('mirrorManagement.selectRegion')">
            <el-option
              v-for="item in regionData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('mirrorManagement.status')" prop="status">
          <el-select v-model="formLabelAlign.status" :placeholder="$t('mirrorManagement.selectStatus')">
            <el-option
              v-for="item in statusData"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('mirrorManagement.bashAddress')" prop="bashFile">
          <el-input v-model="formLabelAlign.bashFile" :placeholder="$t('mirrorManagement.enterBashAddress')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createCode">{{ $t('mirrorManagement.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postRequest } from '@/common/libs/request';
import { Message } from 'element-ui';
import { debounce, filterRegionList, regionList } from '@/common/utils/utils';

export default {
  name: 'mirrorManagement',
  data() {
    return {
      tableData: [], // 镜像列表
      dialogVisible: false,
      platformOptions: [{
        value: 'ubuntu',
        label: 'ubuntu',
      }, {
        value: 'centos',
        label: 'centos',
      }, {
        value: 'windows',
        label: 'windows',
      }, {
        value: 'tlinux',
        label: 'tlinux',
      }],
      regionData: regionList,
      statusData: [{
        value: 1,
        label: this.$t('mirrorManagement.available'),
      }, {
        value: 2,
        label: this.$t('mirrorManagement.unavailable'),
      }],
      filterRegionList,
      formLabelAlign: {
        name: '',
        value: '',
        disk: '50',
        platform: '',
        region: '',
        status: '',
        bashFile: '',
        osName: ''
      },
      dialogTitle: this.$t('mirrorManagement.createImage'),
      dialogType: 'add',
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
      filterPlatform: [],
      filterRegion: '',
      imageIds: '',
    };
  },
  created() {
    this.getList();
  },

  methods: {
    openDialog() {
      this.dialogType = 'add';
      this.dialogTitle = this.$t('mirrorManagement.createImage');
      this.formLabelAlign = {
        name: '',
        value: '',
        disk: '50',
        platform: '',
        status: '',
        bashFile: '',
        osName: '',
      };
      this.dialogVisible = true;
    },

    /**
     * 筛选镜像列表
     */
    filterGetList() {
      this.pageIndex = 1;
      this.tableDataTotal = 0;
      this.getList();
    },

    /**
     * 获取镜像列表
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      const params = {
        offset,
        limit: this.pageLimit,
        imageType: 'SHARED_IMAGE',
        platformList: this.filterPlatform,
        region: this.filterRegion,
        imageIds: [],
      };
      if (this.imageIds) {
        params.imageIds = this.imageIds.split('|');
      }
      postRequest('/api/eda/common/admin/getImageList', params).then((res) => {
        this.tableData = res.list || [];
        this.tableDataTotal = res.total;
      });
    },

    /**
     * 创建镜像
     */
    createCode() {
      this.formLabelAlign.disk = +this.formLabelAlign.disk;
      debounce(() => {
        if (this.dialogType === 'add') {
          postRequest('/api/eda/common/admin/createImage', this.formLabelAlign).then(() => {
            Message.success(this.$t('mirrorManagement.createSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        } else {
          postRequest('/api/eda/common/admin/updateImage', this.formLabelAlign).then(() => {
            Message.success(this.$t('mirrorManagement.updateSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        }
      }, 500);
    },

    /**
     * 编辑镜像
     */
    editImage(e) {
      this.dialogType = 'edit';
      this.dialogTitle = this.$t('mirrorManagement.editImage');
      this.formLabelAlign = Object.assign({}, e);
      this.dialogVisible = true;
    },

    /**
     * 删除镜像
     */
    deleteImage(id) {
      this.$confirm(this.$t('mirrorManagement.deleteConfirm'), this.$t('mirrorManagement.deleteImage'), {
        confirmButtonText: this.$t('mirrorManagement.confirm'),
        cancelButtonText: this.$t('common.cancel'),
      }).then(() => {
        postRequest('/api/eda/common/admin/deleteImage', { id: +id }).then(() => {
          this.filterGetList();
          Message.success(this.$t('mirrorManagement.deleteSuccess'));
        });
      })
        .catch(() => {
          console.log('cancel');
        });
    },

    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
// table 背景颜色+padding10px
.mirror_table {
  background: #fff;
  padding: 10px;
  height: calc(100% - 82px);
  margin-top: 10px;

  .table {
    height: calc(100% - 82px);

    ::v-deep .el-table__body-wrapper {
      height: calc(100% - 82px);
      overflow-y: auto;
    }
  }

  //::v-deep .el-table__body-wrapper {
  //  height: calc(100% - 68px);
  //  overflow-y: auto;
  //}

  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}
</style>
